var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerPole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 19.2,
    width: 40,
    height: 1.6,
    fill: "#575656"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.12256,
    y: 14.689,
    width: 0.841885,
    height: 5.33194,
    fill: "#575656"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5215,
    y: 14.689,
    width: 0.841885,
    height: 5.33194,
    fill: "#575656"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1343,
    y: 19.1791,
    width: 0.561257,
    height: 5.33194,
    fill: "#575656"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5374,
    y: 23.9497,
    width: 0.561257,
    height: 2.24503,
    transform: "rotate(90 25.5374 23.9497)",
    fill: "#575656"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5569 18.3372L17.1182 19.4597L3.36738 19.4597L3.92863 18.3372L16.5569 18.3372Z",
    fill: "#575656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41897 24.2304C9.81385 24.2304 10.9446 23.0996 10.9446 21.7047C10.9446 20.3099 9.81385 19.1791 8.41897 19.1791C7.02408 19.1791 5.89331 20.3099 5.89331 21.7047C5.89331 23.0996 7.02408 24.2304 8.41897 24.2304ZM8.419 22.8273C9.03895 22.8273 9.54152 22.3247 9.54152 21.7048C9.54152 21.0848 9.03895 20.5822 8.419 20.5822C7.79906 20.5822 7.29649 21.0848 7.29649 21.7048C7.29649 22.3247 7.79906 22.8273 8.419 22.8273Z",
    fill: "#575656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5925 24.2304C15.9874 24.2304 17.1182 23.0996 17.1182 21.7047C17.1182 20.3099 15.9874 19.1791 14.5925 19.1791C13.1977 19.1791 12.0669 20.3099 12.0669 21.7047C12.0669 23.0996 13.1977 24.2304 14.5925 24.2304ZM14.5926 22.8273C15.2125 22.8273 15.7151 22.3247 15.7151 21.7048C15.7151 21.0848 15.2125 20.5822 14.5926 20.5822C13.9726 20.5822 13.4701 21.0848 13.4701 21.7048C13.4701 22.3247 13.9726 22.8273 14.5926 22.8273Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerPole);
export default __webpack_public_path__ + "static/media/TRAILER_POLE.403f9a93ddc92c372c58b50ec9b1bcfb.svg";
export { ForwardRef as ReactComponent };